import {
  EntityId,
  EntitySelectEntity,
  EntitySelectSubEntity,
} from '@factorialco/f0-react/dist/experimental'
import { AvatarNameForSelectFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

export function groupByTeams(
  employees?: AvatarNameForSelectFragment[],
  excludedIds: EntityId[] = [],
  expandedElements: EntityId[] = []
): EntitySelectEntity[] {
  if (!employees) return []
  const teamMap = new Map<string, EntitySelectEntity>()

  employees.forEach((employee) => {
    const { id, fullName, avatar, firstName, lastName, preferredName } = employee

    const teamMemberships = employee.teamMemberships || []

    teamMemberships.forEach((membership) => {
      const team = membership.team
      const teamId = team?.id || '0'
      const teamName = team?.name || ''

      let teamEntity = teamMap.get(teamId)

      if (!teamEntity) {
        teamEntity = {
          id: teamId,
          name: teamName,
          expanded: expandedElements.includes(teamId),
          subItems: [],
        }
        teamMap.set(teamId, teamEntity)
      }

      const subItem: EntitySelectSubEntity = {
        subId: id,
        subName: fullName,
        subAvatar: avatar ? buildUrl(avatar.url) : undefined,
        subSearchKeys: [
          preferredName ? `${preferredName} ${lastName}` : null,
          `${firstName} ${lastName}`,
        ].filter(Boolean),
      }

      if (!excludedIds.includes(id)) {
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        teamEntity.subItems!.push(subItem)
      }
    })
  })

  return Array.from(teamMap.values())
}
